const Home = () => {
    return (
        <>
            <div></div>
        </>
    );
};

export default Home;
